import { browser } from '$app/environment';

/**
 * Safely retrieve a value from localStorage with error handling.
 * Returns null if localStorage is unavailable or if an error occurs.
 */
export function safeLocalStorageGet<T>(key: string, transform?: (value: unknown) => T): T | null {
	try {
		if (!browser) return null;
		const raw = localStorage.getItem(key);
		if (raw === null) return null;
		const rawJson = JSON.parse(raw);
		return transform ? transform(rawJson) : (rawJson as T);
	} catch (e) {
		console.warn('Error reading from localStorage:', e);
		return null;
	}
}

/**
 * Safely set a value in localStorage with error handling.
 * Silently fails if localStorage is unavailable.
 */
export function safeLocalStorageSet(key: string, value: unknown) {
	try {
		if (!browser) return;
		if (value === null || value === undefined) {
			localStorage.removeItem(key);
		} else {
			localStorage.setItem(key, JSON.stringify(value));
		}
	} catch (e) {
		console.warn('Error writing to localStorage:', e);
	}
}
